export const STARTER = 'starter';
export const ENTERPRISE = 'enterprise';
export const orderedTabs = ['enterprise', 'starter'];

/**
 * Maps tab IDs to the product levels shown for each tab on public pricing pages.
 * This is the source of truth for V2 tab filtering.
 *
 * Note: PROFESSIONAL appears in both tabs to allow tier comparison:
 * - Starter tab: Shows FREE, STARTER, PROFESSIONAL (3 tiers)
 * - Enterprise tab: Shows PROFESSIONAL, ENTERPRISE (2 tiers)
 *
 * V1 Routes.tsx imports this for tab validation but doesn't use the product level arrays.
 */
export const tabIdToProductLevels = {
  [STARTER]: ['FREE', 'STARTER', 'PROFESSIONAL'],
  [ENTERPRISE]: ['PROFESSIONAL', 'ENTERPRISE']
};